import LicenseRecord from './license-record'

export default {
  props:['id','examRecordId'],
  data(){
    return {
      loading:false,
      data:{}
    }
  },
  created(){
    this.$watch('id' , function(nv){
      if(nv){
        this.query()
      }else{
        this.data = null
      }
    },{immediate:true})

    this.$watch('examRecordId' , function(nv){
      if(nv){
        this.queryByExamRecordId(nv)
      }else{
        this.data = null
      }
    },{immediate:true})
    
  },
  methods: {
    query(){
      this.loading = true
      this.$request.courierLicense(this.id).then(resp => {
        this.loading = false
        this.data = resp.data
      })
    },
    queryByExamRecordId(id){
      this.loading = true
      this.$request.licenseInstanceByRecordId(id).then(resp => {
        this.loading = false
        this.data = resp.data
      })
    },
  },
  render(){
    if( !this.data ){
      return <div style="font-size: 14px; color: rgba(0, 0, 0, 0.45); padding: 45px; text-align: center;"><Icon type="ios-basket-outline" style="font-size: 48px; opacity: 0.3; margin-bottom:16px;" /><p>还未申领上岗证</p></div>
    }
    return <div>
      <div style="width:400px;margin:auto;">
        <div class="panel flex" style="margin:32px 0;">
          <div class="item" style="flex: auto;text-align:center;">
            <div class="point" style="color:#2446FA;font-size: 20px; margin-bottom: .6em;"><span>{this.data.scoreTotal || 0}</span>分</div>
            <div class="label" style="font-size:14px;">证照总分</div>
          </div>
          <div class="item" style="flex: auto;text-align:center;">
            <div class="point" style="color:#FEC01A;font-size: 20px; margin-bottom: .6em;"><span>{this.data.actScore || 0}</span>分</div>
            <div class="label" style="font-size:14px;">已扣分数</div>
          </div>
          <div class="item" style="flex: auto;text-align:center;">
            <div class="point" style="color:#F02323;font-size: 20px; margin-bottom: .6em;"><span>{this.data.actNum || 0}</span>次</div>
            <div class="label" style="font-size:14px;">违法次数</div>
          </div>
        </div>
        <sl-img style="width:100%;height:auto;" src={this.data.imgPath} public={true} />
      </div>
      {/*<LicenseRecord id={this.id} />*/}
    </div>
  }
}